import { type ReactNode } from 'react';

interface SchemaOrgProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

export default function SchemaOrg({ data }: SchemaOrgProps) {
  const dataArray = Array.isArray(data) ? data : [data];
  return (
    <>
      {dataArray.map((item, index) => (
        <script
          key={index}
          type="application/ld+json"
          data-dynamic-schema={`inline-${index}`}
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  ) as ReactNode;
}